<template>
  <view class="day-picker-container" :style="style" flex="dir:left main:center cross:center" @click="showPopup">
    <view class="picker-type">{{ pickerTypeStr }}</view>
    <view class="picker-range" flex="dir:left main:right cross:center">
      <template v-if="moment(pickerStart).isSame(moment(pickerEnd))">
        <view class="picker-start">{{ moment(pickerStart).format("YYYY-MM-DD") }}</view>
      </template>
      <template v-else-if="pickerType === 'custom'">
        <view class="picker-start">{{ moment(pickerStart).format("YYYY-MM-DD") }}</view>
        <view class="picker-separator">至</view>
        <view class="picker-start">{{ moment(pickerEnd).format("YYYY-MM-DD") }}</view>
      </template>
      <template v-else>
        <view class="picker-start">{{ moment(pickerStart).format("MM-DD") }}</view>
        <view class="picker-separator">至</view>
        <view class="picker-start">{{ moment(pickerEnd).format("MM-DD") }}</view>
      </template>
    </view>
    <view class="picker-icon">
      <icon name="arrow" />
    </view>
  </view>
  <popup v-model:show="showState" position="top" class="picker-container">
    <Header title="选择时间段">
      <template #leftBtn>
        <view class="icon-btn" @click="closePopup">
          <icon name="close" />
        </view>
      </template>
      <template #rightBtn>
        <icon name="ellipsis" />
      </template>
    </Header>
    <view class="picker-body">
      <view
        v-for="pickerItem of Object.keys(pickerTypeList)"
        :key="pickerItem"
        :class="pickerItemClass(pickerItem)"
        @click="handlePickerType(pickerItem)"
      >
        {{ pickerTypeList[pickerItem] }}
      </view>
    </view>
    <view v-if="pickerType === 'custom'" class="date-picker" flex="dir:left main:center cross:center">
      <view class="pft-input" @click="handleShowPicker('start')">
        <field v-model="pickerStart" :readonly="true" :border="false" left-icon="calendar-o" placeholder="开始日期"> </field>
      </view>
      <view class="date-picker-separator">至</view>
      <view class="pft-input" @click="handleShowPicker('end')">
        <field v-model="pickerEnd" :readonly="true" :border="false" left-icon="calendar-o" placeholder="结束日期"> </field>
      </view>
    </view>
    <view class="pft-btn-container">
      <Button @click="handelConfirmDay" type="primary">确定</Button>
    </view>
  </popup>
  <popup v-model:show="pickerShowState" class="pft-date-picker-popup" position="bottom">
    <view class="pft-date-picker-container" v-if="pickerShowState">
      <date-picker v-model="pickerValue" :min-date="rangeMin" :max-date="rangeMax" @confirm="handlePickerConfirm" @cancel="handlePickerCancel" />
    </view>
  </popup>
</template>

<script lang="ts" setup>
import Header from "../Header/index.vue"
import { ref, computed } from "vue"
import moment from "moment"
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Icon, Popup, Field, Button, DatePicker } from "vant"

enum PickerType {
  TODAY = "today",
  YESTERDAY = "yesterday",
  PAST7DAYS = "past7days",
  PAST30DAYS = "past30days",
  PAST90DAYS = "past90days",
  CUSTOM = "custom",
}

const props = withDefaults(
  defineProps<{
    start: string
    end: string
    type: PickerType
    startDay: string
    style?: { [key: string]: string }
  }>(),
  {
    start: () => "2023-01-01",
    end: () => "2023-01-31",
    type: () => PickerType.PAST7DAYS,
    startDay: () => "2018-01-01",
    style: () => ({}),
  },
)

const emits = defineEmits<{
  (
    e: "change",
    value: {
      start: string
      end: string
      type: PickerType
    },
  ): void
  (e: "update:start", value: string): void
  (e: "update:end", value: string): void
  (e: "update:type", value: PickerType): void
}>()

const pickerTypeList = {
  today: "今日",
  yesterday: "昨日",
  past7days: "近7天",
  past30days: "近30天",
  past90days: "近90天",
  custom: "自定义",
}
const startDate = moment(props.startDay)
const nowDate = moment()

// const years = nowDate.diff(startDate, "years")

// for (let i = 1; i <= years; i++) {
//   const year = nowDate.clone().subtract(i, "years").format("YYYY")
//   pickerTypeList[year] = `${year}年`
// }

const showState = ref(false)
const pickerType = ref(props.type)
const pickerStart = ref(props.start)
const pickerEnd = ref(props.end)
const pickerTypeStr = computed(() => {
  return pickerTypeList[pickerType.value]
})
const pickerShowState = ref(false)
const pickerValue = ref([nowDate.format("YYYY"), nowDate.format("MM"), nowDate.format("DD")])
const pickerRangeType = ref("start")

const rangeMin = computed(() => {
  if (pickerRangeType.value === "start") {
    const beginDate = startDate.toDate()
    return beginDate
  } else {
    const maxDate = moment(pickerStart.value).toDate()
    const today = new Date()
    return maxDate > today ? today : maxDate
  }
})

const rangeMax = computed(() => {
  if (pickerRangeType.value === "start") {
    const maxDate = moment(pickerEnd.value).toDate()
    return maxDate
  } else {
    const maxDate = moment().subtract(1, "days").toDate()
    return maxDate
  }
})

const handlePickerType = (type: any) => {
  pickerType.value = type
}
const pickerItemClass = (curType: string) => {
  return {
    "picker-item": true,
    "picker-item-active": pickerType.value === curType,
  }
}
const showPopup = () => {
  showState.value = true
}
const closePopup = () => {
  showState.value = false
}
const handlePickerConfirm = (opt: { selectedValues: string[] }) => {
  if (pickerRangeType.value === "start") {
    pickerStart.value = opt.selectedValues.join("-")
  } else {
    pickerEnd.value = opt.selectedValues.join("-")
  }
  pickerShowState.value = false
}
const handleShowPicker = (type: string) => {
  pickerRangeType.value = type
  if (type === "start") {
    const startMmt = moment(pickerStart.value)
    pickerValue.value = [startMmt.format("YYYY"), startMmt.format("MM"), startMmt.format("DD")]
  } else {
    const endMmt = moment(pickerEnd.value)
    pickerValue.value = [endMmt.format("YYYY"), endMmt.format("MM"), endMmt.format("DD")]
  }
  pickerShowState.value = true
}
const handelConfirmDay = () => {
  let startmmt = moment(pickerStart.value)
  let endmmt = moment(pickerEnd.value)
  switch (pickerType.value) {
    case "today":
      startmmt = nowDate.clone().subtract(1, "days")
      endmmt = nowDate.clone().subtract(1, "days")
      break
    case "yesterday":
      startmmt = nowDate.clone().subtract(2, "days")
      endmmt = nowDate.clone().subtract(2, "days")
      break
    case "past7days":
      startmmt = nowDate.clone().subtract(7, "days")
      endmmt = nowDate.clone().subtract(1, "days")
      break
    case "past30days":
      startmmt = nowDate.clone().subtract(30, "days")
      endmmt = nowDate.clone().subtract(1, "days")
      break
    case "past90days":
      startmmt = nowDate.clone().subtract(90, "days")
      endmmt = nowDate.clone().subtract(1, "days")
      break
    case "custom":
      break
  }
  if (startmmt.isBefore(startDate)) {
    startmmt = startDate
  }
  if (endmmt.isBefore(startDate)) {
    endmmt = startDate
  }
  pickerStart.value = startmmt.format("YYYY-MM-DD")
  pickerEnd.value = endmmt.format("YYYY-MM-DD")
  emits("change", {
    start: pickerStart.value,
    end: pickerEnd.value,
    type: pickerType.value,
  })
  emits("update:start", pickerStart.value)
  emits("update:end", pickerEnd.value)
  emits("update:type", pickerType.value)
  // store.commit("app/SET_DAY_PICKER_OPT", {
  //   type: pickerType.value,
  //   start: pickerStart.value,
  //   end: pickerEnd.value,
  // })
  showState.value = false
}
const handlePickerCancel = () => {
  pickerShowState.value = false
}
</script>

<style lang="scss">
.day-picker-container {
  height: 44px;
  margin: 4px 16px;
  width: calc(100% - 32px);
  background: rgba(36, 57, 89, 0.75);
  border-radius: 12px;
  padding: 8px 12px;
  box-sizing: border-box;
  .picker-type {
    font-size: 14px;
    color: #fff;
    font-weight: bold;
  }
  .picker-range {
    flex-grow: 1;
    .picker-start,
    .picker-end {
      font-size: 12px;
      color: #2b97f7;
      line-height: 20px;
    }
    .picker-separator {
      font-size: 12px;
      color: #2b97f7;
      margin: 0 4px;
    }
  }
  .picker-icon {
    margin-left: 4px;
    line-height: 20px;
  }
}
.picker-container {
  width: 100%;
  height: 100%;
  background: var(--pft-page-background-color, #0f152b) !important;
  display: flex;
  flex-direction: column;
  .picker-body {
    padding: 18px;
    box-sizing: border-box;

    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    .picker-item {
      font-family:
        Source Han Sans CN,
        Source Han Sans CN;
      color: #e5eaf3;
      font-size: 14px;
      line-height: 32px;
      width: 101px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #1d2d47;
      border: 1px solid #1d2d47;
      border-radius: 4px;
      margin: 6px;
      &.picker-item-active {
        color: #2bb7f7;
        background: #122e5b;
        border: 1px solid #2bb7f7;
      }
    }
  }
}
.date-picker {
  padding: 0 24px;
  .date-picker-separator {
    font-size: 12px;
    color: #fff;
    margin: 0 10px;
  }
}
.pft-input {
  --van-field-input-text-color: #fff;
  .van-field {
    width: 100%;
    height: 40px;
    background: #1d2d47;
    border-radius: 3px;
    font-size: 14px;
    color: #fff;
    .nut-input-inner {
      height: 100%;
      .nut-input-left-box {
        margin-right: 10px;
        color: #f5f5f5;
      }
      .input-text {
        font-size: 14px;
        color: #fff;
      }
    }
  }
  .pft-input-placeholder {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.3);
  }
}
.pft-date-picker-popup {
  background: #122e5b;
  --van-picker-option-text-color: #fff;
  --van-picker-option-text-active-color: #2bb7f7;
  --van-picker-option-text-disabled-color: #999;
  --van-picker-confirm-button-text-color: #2bb7f7;
  --van-picker-background: #122e5b;
  --van-popup-background: #122e5b;
  --van-picker-mask-color: liner-gradient(180deg, rgb(18 46 91), rgba(38, 77, 140, 0.4)), linear-gradient(0deg, rgb(18 46 91), rgba(38, 77, 140, 0.4));
  ul {
    margin: 0;
    padding-left: 0;
    li + li {
      margin: 0;
    }
  }
}
.pft-btn-container {
  padding: 24px;
  box-sizing: border-box;
  .nut-button {
    width: 100%;
    height: 40px;
    font-size: 14px;
  }
}
</style>
